module.exports = __webpack_public_path__ + "img/line.cce39ba6.svg";